'use client'

import { usePathname, useRouter } from 'next/navigation'

import { AgreementContentRenderer, GroupMenu, Hero } from '@/components'
import termsAndCondition from '@/libs/constants/terms-and-condition'

export default function TermsAndCondition() {
  const { push } = useRouter()
  const pathname = usePathname()
  const listGroupMenu = [
    {
      name: 'terms-and-condition',
      title: 'Terms',
    },
    {
      name: 'privacy-policy',
      title: 'Privacy',
    },
  ]

  return (
    <>
      <Hero pathname={pathname} />
      <GroupMenu
        listMenu={listGroupMenu}
        selectedMenu='terms-and-condition'
        onClick={(e) => push(`/articles/${e}`)}
      />
      <main className='relative flex flex-row'>
        <div className='mx-auto w-full md:flex-grow'>
          <div className='mx-auto flex flex-col gap-4 px-5 py-4 md:px-12 md:py-6 lg:w-3/4 lg:py-9 xl:w-1/2 xl:py-12'>
            <h1 className='text-sm font-bold'>Last updated on August 2024</h1>
            <p className='text-xs font-normal leading-5'>
              Thank you for visiting our website Web Respondent by Populix, (“Website”). Please read
              these Terms & Conditions (“Terms & Conditions”) of PT Populix Informasi Teknologi
              (“We”). This Terms & Conditions govern Your use of Website. User is advised to read
              this Terms and Conditions because it may affect their rights and obligations under the
              law.
            </p>
            <div className='text-xs font-normal leading-5'>
              <p>You or User shall mean the following:</p>
              <ol className='list-outside'>
                <li>a. Any person who opens and/or accesses Website.</li>
                <li>
                  b. Any person who participates in a survey or study that is available on the
                  Website.
                </li>
              </ol>
            </div>
            <AgreementContentRenderer content={termsAndCondition} />
          </div>
        </div>
      </main>
    </>
  )
}
